export default __webpack_public_path__ + "diagrama2024-es.png";